module.exports = __webpack_public_path__ + "img/educacion.181569e8.jpg";